import { ReducerConfig } from "./core/redux/model/reducer-config.model";
import { routerReducer } from "@angular-redux/router";
import { environment } from "../environments/environment";
import { Injectable } from "@angular/core";
import { LocaleServiceConfig } from "./core/locale/locale.module";
import { LoadingMaskConfig } from "./component/loadingmask/loadingmask.config.model";
import { FormatterServiceConfig } from "@core/formatter/formatter.module";

// formatter config
export const formatterServiceConfig: FormatterServiceConfig = {
  defaultDateFormat: "yyyy.MM.dd"
};

// Resource config
export const localeConfig: LocaleServiceConfig = {
  availableLocales: ["hu", "en"],
  defaultLocale: "hu"
};

// Redux config
export const ROUTER_STATE_NAME = "router";
export const reducerConfig: ReducerConfig = {
  [ROUTER_STATE_NAME]: routerReducer
};

const _config = {
  "environment": environment,
  "apiUrl": "/passwordmanagement"
};

// API config
export const remoteApiUrl = environment.apiUrl;

// Loading maszk kivételek, ahol nem kell megjelennie
export const loadingMaskConfig: LoadingMaskConfig = {
  urlBlackList: [
    "/revive"
  ]
};

@Injectable()
export class AppConfigService {

  public get config(): any {
    return _config;
  }

  constructor() {
  }
}

